export default {"src":"/_next/static/media/cx4.7bf92cc4.svg","height":121,"width":119,"blurWidth":0,"blurHeight":0};